import { render, staticRenderFns } from "./ActionChipV2026.vue?vue&type=template&id=4243c6f9&scoped=true"
import script from "./ActionChipV2026.vue?vue&type=script&lang=js"
export * from "./ActionChipV2026.vue?vue&type=script&lang=js"
import style0 from "./ActionChipV2026.vue?vue&type=style&index=0&id=4243c6f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4243c6f9",
  null
  
)

export default component.exports